import { ViewDirection } from '../GameKit/shared';

export const GameGoalFlag = {
    DIE: 0,
    FINISH: 1 << 0,
    POINT_LIMIT: 1 << 1,
    TIME_LIMIT: 1 << 2,

    // UPDATE THIS NUMBER WHEN ADDING MORE FLAGS
    getMaxShift() {
        return 2;
    },

    getString(val) {
        if (val === GameGoalFlag.DIE) return 'Speel tot je dood gaat';
        if (val & GameGoalFlag.FINISH) return 'Haal de finish';
        if (val & GameGoalFlag.POINT_LIMIT) return 'Haal een vast aantal punten';
        if (val & GameGoalFlag.TIME_LIMIT) return 'Haal je doel voor de tijd om is';
        return 'Onbekende optie';
    },

    getIcon(val) {
        if (val & GameGoalFlag.FINISH) return 'finish.png';
        if (val & GameGoalFlag.POINT_LIMIT) return 'muntje.png';
        if (val & GameGoalFlag.TIME_LIMIT) return 'clock.png';
        return 'bouwsteen-sluit.png';
    }
};

export const GameScoreEnum = {
    NONE: 0,
    FAST: 1,
    SLOW: 2,
    OUT_OF_BOUNDS: 3,

    // enum functions
    checkOOB(val) {
        if (val < GameScoreEnum.NONE) {
            return GameScoreEnum.NONE;
        }
        if (val >= GameScoreEnum.OUT_OF_BOUNDS) {
            return GameScoreEnum.OUT_OF_BOUNDS - 1;
        }
        return val;
    },

    getString(val) {
        switch (val) {
            case GameScoreEnum.NONE:
                return 'Nee';
            case GameScoreEnum.FAST:
                return 'Ja, speel zo snel mogelijk';
            case GameScoreEnum.SLOW:
                return 'Ja, houd het zo lang mogelijk vol';
            default:
                return 'Onbekende optie';
        }
    }
};

export const DefaultLevelSettings = {
    title: '',
    description: '',
    backgroundA: 0xff8800,
    backgroundB: 0xff0000,
    view: ViewDirection.Side,
    timeLimit: 10,
    timeLimitMin: 10,
    timeLimitMax: 600,
    timeLimitRangeSliderStep: 5,
    timeLimitStep: 1,
    pointsGoal: 5,
    pointsGoalMin: 1,
    pointsGoalMax: 100,
    pointsGoalStep: 5
};
